module.exports = __webpack_public_path__ + "img/guest-null.11ce0dbe.jpg";